import objectPath from 'object-path'
import h from 'virtual-dom/h'
import { makeFlag } from '../../../state-flagger/src/state-flagger';
import getHistoryWatcher from '../../../history-watcher/src/history-watcher';
import { sendRequest, sendExtensibleRequest } from '../../../lib-alme-request/src/lib-alme-request';
import {enableInputBox, disableInputBox, SendRequestAndReEnableInputBox} from '../../../lib-inputbox-toggle/lib/lib-inputbox-toggle';
export default class Renderers {
    constructor(settings, options={}, clientHistoryWatcher, commandActionHandler=null) {
        this._settings  = settings;
        this._css     = settings.classNames;
        this._options = options;
        this._clientHistoryWatcher = clientHistoryWatcher;
        this._commandActionHandler = commandActionHandler;
    }

    initialize(store) {
        this._store    = store;
        this._suppressTab = makeFlag(store, this._options.suppressTab);

        this._pendingApiRequest = false;
        this._historyWatcher = !!this._clientHistoryWatcher ? this._clientHistoryWatcher(this._settings, store) : getHistoryWatcher(this._settings, store);
        this._historyWatcher.registerHandlers(() => this._pendingApiRequest = true,
                                              () => this._pendingApiRequest = false);
    }

    getRender() { return () => {} }

    getNew(options={}) { 
        let newInstance = new Renderers(this._settings, options);
        newInstance.initialize(this._store);
        return newInstance;
    }

    linksMapper(spec, response=null) {
        const validTargets = ['url', 'unit', 'input', 'header', 
                              'appevent', 'handleronly', 'extensiblerequest'];
        const empty = () => [];
        let target  = spec.TargetType.toLowerCase();
        let isValid = validTargets.indexOf(target) !== -1;
        let maker   = isValid ? this[target].bind(this) : empty;

        return maker(spec, spec.Metadata, response);
    }

    url(spec, metadata, response=null) {
        let { NavigationType, UrlAddress } = metadata;
        let { linkTypes, hoverText } = this._settings.navConstants;
        let target = (NavigationType === linkTypes.popup) ? '_blank' : '_self';

        return this.renderWrappedLink(
            spec, UrlAddress, hoverText.urlHoverTextPath, { target },
            'DisplayText', {}, response
        );
    }

    unit(spec, metadata, response=null) {
        return this.renderWrappedLink(spec, (e) => {
            this.start(spec)(e);
            if (!this._pendingApiRequest) {
                const input = { 
                    unitId: metadata.UnitUID,
                    displayText: spec.DisplayText,
                    parameters: spec.parameters,
                    origin: this._settings.originConstants.click,
                    messageType: this._settings.messageConstants.requestUnitRequest,
                };
                disableInputBox(this._store, this._settings, () => true);
                SendRequestAndReEnableInputBox(input, this._store, this._settings, true);
                this._historyWatcher.requestSent();
            }
            return this.finish(spec)(e);
        }, 'DisplayText', {}, response);
    }

    input(spec, metadata, response=null) {
        return this.renderWrappedLink(spec, (e) => {
            this.start(spec)(e);
            if (!this._pendingApiRequest) {
                const input = {
                        text: metadata.InputText,
                        displayText: spec.DisplayText,
                        parameters: spec.parameters,
                        origin: spec.parameters.origin || this._settings.originConstants.click,
                        messageType: this._settings.messageConstants.converseRequest, 
                };
                disableInputBox(this._store, this._settings, () => true);
                SendRequestAndReEnableInputBox(input, this._store, this._settings)
                this._historyWatcher.requestSent();
            }
            return this.finish(spec)(e);
        }, 'DisplayText', {}, response);
    }

    handleronly(spec, response=null, resp=response) {
        return this.renderWrappedLink(spec, this.finish(spec), 'DisplayText', {}, resp);
    }

    header(spec) {
        let attrs = { className: this._css.displayLinksSectionHeader };
        return h('div', attrs, spec.DisplayText);
    }

    appevent(spec, response=null, resp=response) {
        let params = spec.parameters;
        return this.renderBareLink(spec, (e) => {
            this.start(spec)(e);
            if (!this._pendingApiRequest) {
                params = typeof params === 'function' ? params() : params;
                const input = {
                    eventName: spec.AppeventName,
                    parameters: params,
                    origin: this._settings.originConstants.external,
                    messageType: this._settings.messageConstants.appeventRequest,
                };
                disableInputBox(this._store, this._settings, () => true);
                SendRequestAndReEnableInputBox(input, this._store, this._settings)
                this._historyWatcher.requestSent();
            }
            return this.finish(spec)(e);
        }, 'DisplayText', {}, resp);
    }

    extensiblerequest(spec, response=null, resp=response) {
        let params = spec.parameters;
        return this.renderBareLink(spec, (e) => {
            this.start(spec)(e);
            if(!this._pendingApiRequest) {
                params = typeof params === 'function' ? params() : params;

                let input = {
                    messageType: this._settings.messageConstants.extensibleRequest,
                    messageSource: spec.SourceName,
                    endpoint: spec.Endpoint,
                };

                input = Object.assign({}, input, params)
                disableInputBox(this._store, this._settings, () => true);
                const prom = Promise.resolve(sendExtensibleRequest(input, spec.Method));
                prom.then((value) => {

                    enableInputBox(this._store, this._settings, () => true);

                });
                this._historyWatcher.requestSent();
            }
            return this.finish(spec)(e);
        }, 'DisplayText', {}, resp);
    }

    start(spec) {
        return (e) => {
            if (typeof spec.PreAlme === 'function') {
                return spec.PreAlme(e);
            }
        }
    }


    // Don't use for URL links or navigation won't happen.
    finish(spec) {
        return (e) => {
            if (typeof spec.Handler === 'function') // Optional handler
                setTimeout(() => spec.Handler(e), 0);

            // Stop event bubbling and DOM actions
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
    }

    renderWrappedLink(linkSpec, ref, titlePath='DisplayText', spec={}, response=null) {
        let a   = this.renderBareLink(linkSpec, ref, titlePath, spec, response);
        let div = h('div', { className: this._css.displayLink }, [a]);
        return div;
    }

    renderBareLink(linkSpec, ref, titlePath='DisplayText', spec={}, response=null) {
        const stopProp = (e) => {
            e.stopPropagation();// Don't bubble
            if(linkSpec.PreAlme && typeof linkSpec.PreAlme === 'function')
                linkSpec.PreAlme(e);
        };
        let title = objectPath.get(linkSpec, titlePath) || (void 0);
        let href = this._suppressTab.active() ? (void 0) : (typeof ref === 'string' ) ? ref : '#';
        let onclick = (e) => {
            if (typeof ref === 'string'   ) { stopProp(e); }
            if (typeof ref === 'function' ) { ref(e); }
            if (this._commandActionHandler) {
                this._commandActionHandler.processLink(
                    response, linkSpec, false, this._settings.originConstants.click
                );
            }
        };
        let baseSpec = { href, title, onclick };

        let tag = linkSpec.tag ? linkSpec.tag : 'a';
        if(linkSpec.className){
            spec.className = linkSpec.className;
        }
        if(linkSpec.attributes){
            spec.attributes = linkSpec.attributes;
        }
        if(linkSpec.id){
            spec.id = linkSpec.id;
        }
        if (linkSpec.disabled) {
            baseSpec.href = '/';
            baseSpec.onclick = () => false;
            baseSpec.tabIndex = -1;
        }

        return h(tag, Object.assign(baseSpec, spec), linkSpec.DisplayText);
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/single-link-renderer/src/renderers/renderer.js